import { render, staticRenderFns } from "./addrate.vue?vue&type=template&id=6a6aea08&scoped=true&"
import script from "./addrate.vue?vue&type=script&lang=js&"
export * from "./addrate.vue?vue&type=script&lang=js&"
import style0 from "./addrate.vue?vue&type=style&index=0&id=6a6aea08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6aea08",
  null
  
)

export default component.exports